import AsyncStorage from '@react-native-async-storage/async-storage';

export async function getObjectKey(
  key: string,
  allowString = false,
): Promise<Record<string, any> | null> {
  const v = await AsyncStorage.getItem(key);
  // @ts-ignore
  let ret: Record<string, any> | null = v;
  try {
    // @ts-ignore
    ret = JSON.parse(v);
  } catch (error) {
    if (!allowString) {
      ret = null;
    }
  }
  return ret;
}
